import {PictureSearchModel} from '../PictureSearchModel';
import {PriceModel} from '../PriceModel';

export class ProductViewModel {
  public code: number;
  public name: string = null;
  public picture: PictureSearchModel;
  public price: PriceModel;
  public frameColour: string = null;
  public brandName: string = null;
  public url: string = null;
  public discountPrice: PriceModel;
  public vtoId: string;
  public buttons: Array<any>;

  static simple(_name: string) {
    const simple = new ProductViewModel();

    simple.name = _name;
    simple.code = 111;
    simple.picture = PictureSearchModel.sample();
    simple.price = PriceModel.sample();
    simple.discountPrice = PriceModel.sample();
    simple.frameColour = 'Blue';
    simple.brandName = 'Fork';
    simple.url = '/simple';
    simple.discountPrice = PriceModel.sample();
    simple.vtoId = 'default';

    return simple;
  }
}
